<template>
  <div
    id="app"
    v-if="hasInitLang">
    <headerCc
      v-if="noBlankPage"
      @ShowPop="IsPopShow = true"></headerCc>
    <!-- 状态搜索弹出框 -->
    <secondary-record
      v-if="IsPopShow && noBlankPage"
      @HiddenPop="IsPopShow = false"></secondary-record>
    <el-main class="scrollbar">
      <router-view :key="dataMark"></router-view>
    </el-main>
    <iframe
      name="loginIframe"
      id="loginIframe"
      frameborder="no"
      style="display:none;position: absolute;top: -80px;left:0;z-index: 1000000;background: rgba(37,37,37,0.3);height: calc(100% + 80px)"
      :src="signUrl"></iframe>
  </div>
</template>

<script>
import HeaderCc from '@/components/common/HeaderCc'
import { mapActions, mapState } from 'vuex'
import Bus from '@/assets/js/vueBus.js'
import { loadSudoku, loadLanguageJs } from '@/assets/js/loadSudoku.js'
import SecondaryRecord from '@/views/PlayoutPlus/common/SecondaryRecord.vue'
import toTips from '@/assets/js/toTipsObj'
import '@/assets/js/messenger.js'
import { loginConfig } from '@/assets/js/common/creatAccount.js'
import Tool from '@/assets/js/utils'
export default {
  name: 'App',
  data () {
    return {
      //   不是空白页
      noBlankPage: true,
      dataMark: '',
      visible: {
        notice: false
      },
      noticeMsg: [],
      role: null,
      // 是否显示状态弹出框
      IsPopShow: false,
      childMountedTimer: null,
      signUrl: window.location.host.includes('cn') ? loginConfig.loginUrlCn : loginConfig.loginUrlCom
    }
  },
  components: {
    HeaderCc,
    SecondaryRecord
  },
  computed: {
    ...mapState('common', {
      hasInitLang: (state) => state.hasInitLang
    }),
    playoutUrl () {
      return this.$store.state.common.baseUrl.playoutUrl
    },
    playoutServerName () {
      return this.$store.state.common.baseUrl.playoutServerName
    }
  },
  created () {
    const exitCookie = Tool.getCookie('SID')
    const host = window.location.host
    if (exitCookie && exitCookie.length == 32) {
      const environmentUrl = window.location.host.includes('com') ? loginConfig.urlCom : loginConfig.urlCn
      if (environmentUrl.includes('channel.tvunetworks') && (host.includes('channel.tvunetworks') || host.includes('userservice-test.tvunetworks'))) {
        const redirectUrl = `${environmentUrl}?session=${exitCookie}`
        window.top.location.href = redirectUrl
      } else if (host.includes('channel-dev.tvunetworks.com')) {
        const redirectUrl = `${loginConfig.devurl}?session=${exitCookie}`
        window.top.location.href = redirectUrl
      }
    }
    if (host.includes('channel-dev.tvunetworks.com')) {
      this.signUrl = loginConfig.loginUrldev
    } else {
      this.signUrl = window.location.host.includes('cn') ? loginConfig.loginUrlCn : loginConfig.loginUrlCom
    }
    // 当全局变量存储好之后开始调用language公共js
    loadLanguageJs()
    this.identify()
  },
  mounted () {
    this.setRem()
    // document.cookie = 'aa=123;path=/;domain=.tvunetworks.com;secure'
  },
  methods: {
    // ...mapActions('common', ['baseUrl', 'baseUserInfo']),
    setRem () {
      // let whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
      // let wW = window.innerWidth; // 当前窗口的宽度
      const rem = 100 // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
      $('html').css('font-size', `${rem}px`)
      $(window).resize(() => {
        // let whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
        // let wW = window.innerWidth; // 当前窗口的宽度
        // const rem = 100 // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
        $('html').css('font-size', `${rem}px`)
      })
    },
    // 是否为第一次登陆进来
    isLogin () {
      if (localStorage.getItem('channelSession') != localStorage.getItem('lastSession')) {
        localStorage.setItem('lastSession', localStorage.getItem('channelSession'))
        return true
      }
      return false
    },
    identify () {
      window.Appcues.identify()
    }
  },
  watch: {
    hasInitLang (val) {
      if (this.hasInitLang) {
        // 初始化Messenger对象
        const that = this
        setTimeout(() => {
          const iframe = document.getElementById('loginIframe')
          window.messenger = new Messenger('loginParent', 'loginMessenger')
          messenger.addTarget(iframe.contentWindow, 'loginIframe')
          this.childMountedTimer = setInterval(() => {
            if (messenger.targets.loginIframe) {
              clearInterval(this.childMountedTimer)
              messenger.targets.loginIframe.send(JSON.stringify({
                type: 'init',
                data: {
                  serverName: loginConfig.serverName,
                  url: window.location.host.includes('com') ? loginConfig.urlCom : loginConfig.urlCn,
                  lang: localStorage.getItem('lang') || navigator.language || navigator.userLanguage,
                  activityCode: loginConfig.activityCode
                }
              }))
            }
          }, 100)
          messenger.listen((obj) => {
            obj = JSON.parse(obj)
            // 登录页
            if (obj.type == 'login') {
              localStorage.setItem('email', obj.data.email)
              localStorage.setItem('firstName', obj.data.firstName)
              localStorage.setItem('userName', obj.data.userName)
              localStorage.setItem('session', obj.data.session)
              localStorage.setItem('userservice', obj.data.userservice)
              window.userservice = obj.data.userservice
              window.document.cookie = `SID=${obj.data.session};path=/;domain=.tvunetworks.com;secure`

              window.top.location.href = obj.data.redirectUrl
            }
            // 隐藏Iframe，试用
            if (obj.type == 'close') {
              iframe.style.display = 'none'
            }
          })
        }, 1000)
      }
    },
    $route (to, from) {
      this.dataMark = to.path
      this.noBlankPage = this.dataMark != '/kb'
      // 执行Websocket
      // if (!this.BehaviorWebsocket) {
      //   if (this.$BehaviorSyns.getProgramId()) {
      //     this.$BehaviorSyns.BehaviorWebsocket('init')
      //   }
      // }
      // 跳转时让弹出框消失
      this.IsPopShow = false
    }
  },
  beforeDestroy () {
    Bus.$off('roleInfo')
  }
}
</script>
<style lang="less">
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // background:#444;
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  background-color: rgba(144, 147, 153, 0.3);
  opacity: 0.7;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 5px;
  background: none;
}
.el-main {
  color: #fff;
  background: #242424;
  height: calc(100% - 80px);
  overflow-y: auto;
}
@media (max-width: 1024px) {
  .el-main {
    height: calc(100% - 60px);
  }
}
</style>
